import { CUSTOM_TAGS } from "./constants.js";
import { CardTag } from "./tags/card.js";
import { ContainerTag } from "./tags/container.js";
import { DataTag } from "./tags/data.js";
import { HeaderTag } from "./tags/header.js";
import { LtrTag } from "./tags/ltr.js";
import { MdTag } from "./tags/md.js";
import { QueryTag } from "./tags/query.js";
import { TrTag } from "./tags/tr.js";
import { VariableTag } from "./tags/variable.js";
import { GoalTag } from "./tags/goal.js";
import { CmsTag } from "./tags/cms.js";
import { DataSourceTag } from "./tags/data_source.js";
const customTags = {
  [CUSTOM_TAGS.CARD]: CardTag,
  [CUSTOM_TAGS.DATA_SOURCE]: DataSourceTag,
  [CUSTOM_TAGS.HEADER]: HeaderTag,
  [CUSTOM_TAGS.QUERY]: QueryTag,
  [CUSTOM_TAGS.LTR]: LtrTag,
  [CUSTOM_TAGS.TR]: TrTag,
  [CUSTOM_TAGS.MD]: MdTag,
  [CUSTOM_TAGS.DATA]: DataTag,
  [CUSTOM_TAGS.CONTAINER]: ContainerTag,
  [CUSTOM_TAGS.VARIABLE]: VariableTag,
  [CUSTOM_TAGS.GOAL]: GoalTag,
  [CUSTOM_TAGS.CMS]: CmsTag
};
export {
  customTags
};
